import {
    MapPin,
    Home,
    Building2,
    Phone,
    User,
    CheckCircle,
} from "lucide-react";

import "./SavedAddressesCard.css";

function SavedAddressesCard({ addresses }) {

    if (!addresses || addresses.length === 0) {

        return (

            <div className="customer-card">

                <h2 className="customer-card-title">

                    Saved Addresses

                </h2>

                <p className="customer-empty">

                    No saved addresses.

                </p>

            </div>

        );

    }

    return (

        <div className="customer-card">

            <h2 className="customer-card-title">

                Saved Addresses

            </h2>

            <div className="saved-addresses-list">

                {addresses.map((address) => (

                    <div
                        key={address._id}
                        className="saved-address-card"
                    >

                        <div className="saved-address-header">

                            <div className="saved-address-type">

                                {address.addressType === "Home" ? (

                                    <Home size={18} />

                                ) : (

                                    <Building2 size={18} />

                                )}

                                <span>

                                    {address.addressType}

                                </span>

                            </div>

                            {address.isDefault && (

                                <span className="default-badge">

                                    <CheckCircle size={14} />

                                    Default

                                </span>

                            )}

                        </div>

                        <div className="saved-address-info">

                            <p>

                                <User size={15} />

                                {address.fullName}

                            </p>

                            <p>

                                <Phone size={15} />

                                {address.phone}

                            </p>

                            <p>

                                <MapPin size={15} />

                                {[
                                    address.houseNo,
                                    address.apartment,
                                    address.street,
                                    address.landmark,
                                    address.area,
                                    address.city,
                                    address.state,
                                    address.pincode,
                                ]
                                    .filter(Boolean)
                                    .join(", ")}

                            </p>

                        </div>

                    </div>

                ))}

            </div>

        </div>

    );

}

export default SavedAddressesCard;